'use client';

import { Mail, MessageCircle, Phone } from 'lucide-react';
import { companyInfo, phoneDisplayFor } from '@/config/company';
import { requestSupport } from '@/lib/support/open-request';

/** Hulpblok onderaan elk artikel: chat, telefoon en e-mail. */
export function HelpContactCta({ labels, locale }: { labels: { title: string; text: string; chat: string; call: string; email: string }; locale?: string }) {
  const phoneHref = `tel:${companyInfo.contact.phone.replace(/\s/g, '')}`;
  return (
    <section aria-labelledby="help-contact-title" className="rounded-3xl border border-blue-200 bg-blue-50 p-6 sm:p-8">
      <h2 id="help-contact-title" className="text-xl font-black text-slate-950">{labels.title}</h2>
      <p className="mt-1 text-slate-700">{labels.text}</p>
      <div className="mt-5 flex flex-wrap gap-3">
        <button
          type="button"
          onClick={() => requestSupport()}
          className="inline-flex items-center gap-2 rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-bold text-white hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        >
          <MessageCircle aria-hidden className="h-4 w-4" />{labels.chat}
        </button>
        <a href={phoneHref} className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-bold text-slate-900 hover:bg-slate-50">
          <Phone aria-hidden className="h-4 w-4" />{labels.call} {phoneDisplayFor(locale)}
        </a>
        <a href={`mailto:${companyInfo.contact.email}`} className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-bold text-slate-900 hover:bg-slate-50">
          <Mail aria-hidden className="h-4 w-4" />{labels.email} {companyInfo.contact.email}
        </a>
      </div>
    </section>
  );
}
